import { jwtDecode } from 'jwt-decode';

function getJwtPayload(token) {
    const decodedToken = jwtDecode(token);
    return decodedToken;
}

function isJwtExpired(token) {
    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        return decodedToken.exp < currentTime; // Check if the token is expired
    } catch (error) {
        console.error('Invalid token:', error);
        return true;
    }
}

export { getJwtPayload, isJwtExpired };
